// extracted by mini-css-extract-plugin
export default {"section":"BjbdIj_Tb_","header":"HsQZzpFUoa","list":"VoPAE8BWJD","item":"QK8ciQiuZD"};